// this file is used to add custom JavaScript functionality to the site

// Defer non-critical JS until after initial render
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCustomScripts);
} else {
  initCustomScripts();
}

function initCustomScripts() {
  (function () {
    function bindCookiebotHeaderClick() {
      var header = document.getElementById("CybotCookiebotDialogHeader");
      if (!header) return false;

      header.setAttribute("role", "button");
      header.setAttribute("tabindex", "0");
      header.setAttribute("aria-expanded", "false");
      header.setAttribute("aria-label", "Show cookie consent options");

      function toggleCookieDialog() {
        var expanded = document.documentElement.classList.toggle("cookie--is-active");
        header.setAttribute("aria-expanded", expanded ? "true" : "false");
      }

      header.addEventListener("click", toggleCookieDialog);

      header.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        toggleCookieDialog();
      });

      return true;
    }

    // Try immediately
    if (bindCookiebotHeaderClick()) return;

    // If not present yet (Cookiebot loads later), observe DOM
    var observer = new MutationObserver(function () {
      if (bindCookiebotHeaderClick()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();

  // flickity mobile icon container height
  (function () {
    function setFlickityViewportHeights() {
      document.querySelectorAll(".flickity-enable-mobile").forEach(function (wrap) {
        var viewport = wrap.querySelector(".flickity-viewport");
        if (!viewport) return;

        var cols = wrap.querySelectorAll(".f-column");
        if (!cols.length) return;

        // Reset to let content size naturally before measuring
        viewport.style.height = "";

        var maxH = 0;

        cols.forEach(function (col) {
          // Use scrollHeight so we capture full content even if nested flex/absolute bits
          var h = col.scrollHeight;

          // Fallback: sometimes scrollHeight is weird if content is positioned
          if (!h) h = col.getBoundingClientRect().height;

          if (h > maxH) maxH = h;
        });

        if (maxH > 0) {
          viewport.style.height = Math.ceil(maxH) + "px";

          // Optional: some Flickity configs need slider height too
          var slider = wrap.querySelector(".flickity-slider");
          if (slider) slider.style.height = Math.ceil(maxH) + "px";
        }
      });
    }

    // Only run this on mobile if you want:
    function runIfMobile() {
      if (window.matchMedia("(max-width: 767px)").matches) {
        setFlickityViewportHeights();
      } else {
        // Optional: clear heights on desktop
        document.querySelectorAll(".flickity-enable-mobile .flickity-viewport").forEach(function (vp) {
          vp.style.height = "";
        });
        document.querySelectorAll(".flickity-enable-mobile .flickity-slider").forEach(function (sl) {
          sl.style.height = "";
        });
      }
    }

    // Run on DOM ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", runIfMobile);
    } else {
      runIfMobile();
    }

    // Run after images/fonts settle
    window.addEventListener("load", runIfMobile);

    // Run on resize/orientation
    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(runIfMobile, 150);
    });
    window.addEventListener("orientationchange", function () {
      setTimeout(runIfMobile, 200);
    });

    // If Flickity initializes after DOMContentLoaded, observe for viewport creation/class
    var obs = new MutationObserver(function () {
      runIfMobile();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  })();

  // flikcity switch
  (function () {
    function initStaticHeroSwap() {
      var wrapper = document.querySelector(".template-index .f-slider-wrapper--mobile-small");
      if (!wrapper) return;

      var flickityMedia = wrapper.querySelector("flickity-component.f-slider__media");
      if (!flickityMedia) return;

      // Single slide: Flickity never initialises and no static hero is rendered, so there is
      // nothing to swap - don't leave an observer waiting on a class that will never arrive.
      if (wrapper.hasAttribute("data-single-slide")) return;

      function markReady() {
        if (wrapper.classList.contains("f-slider-wrapper--flickity-ready")) return;
        wrapper.classList.add("f-slider-wrapper--flickity-ready");

        // Optional: remove static node entirely to reduce DOM
        var staticNode = wrapper.querySelector("[data-static-hero-media]");
        if (staticNode) staticNode.remove();
      }

      // If already enabled
      if (flickityMedia.classList.contains("flickity-enabled")) {
        markReady();
        return;
      }

      // Observe class changes
      var obs = new MutationObserver(function () {
        if (flickityMedia.classList.contains("flickity-enabled")) {
          markReady();
          obs.disconnect();
        }
      });

      obs.observe(flickityMedia, { attributes: true, attributeFilter: ["class"] });

      // Safety: if Flickity never initializes, keep static (do nothing)
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initStaticHeroSwap);
    } else {
      initStaticHeroSwap();
    }
  })();

  function syncAdaptImageWithTextSliderTextHeight() {
    document.querySelectorAll(".f-slider-wrapper--adapt").forEach((wrapper) => {
      const wrapperHeight = wrapper.getBoundingClientRect().height;
      if (!wrapperHeight) return;

      const textSlider = Array.from(wrapper.children).find((el) => el.matches?.("flickity-component.f-slider__text"));
      if (!textSlider) return;

      textSlider.style.height = `${Math.round(wrapperHeight)}px`;
    });
  }

  const runAdaptSync = () => window.requestAnimationFrame(syncAdaptImageWithTextSliderTextHeight);
  if (document.readyState === "complete") {
    runAdaptSync();
  } else {
    window.addEventListener("load", runAdaptSync, { once: true });
  }

  // window.addEventListener("load", () => {
  //   document.querySelectorAll('flickity-component[data-enable-slider="false"]').forEach((el) => {
  //     el.setAttribute("data-enable-slider", "true");
  //   });
  // });

  document.addEventListener("change", function (e) {
    const qtyInput = e.target;
    if (!qtyInput.matches('input[name="updates[]"]')) return;

    const itemRow = qtyInput.closest("[data-line-item]");
    if (!itemRow) return;

    if (itemRow.dataset.freeOrderOnly === "true") {
      if (qtyInput.value > 1) {
        qtyInput.value = 1;
        alert("This product is limited to 1 per order.");
      }
    }
  });

  // dev store
  const isDevStore = window.location.host.includes("skinstation-2025.myshopify.com");

  console.warn("isDevStore", isDevStore);

  if (isDevStore) {
    console.warn("POM limits disabled on dev store");

    // Restore normal add-to-cart button
    const btn = document.querySelector(".f-product-form__submit");
    if (btn && btn.dataset.loginRequired !== "true") {
      btn.removeAttribute("disabled");
    }

    // Fix the button text
    const btnText = document.querySelector(".f-product-form__submit span");
    if (btnText && btn?.dataset.loginRequired !== "true") {
      btnText.textContent = "Add to prescription request";
    }

    // Remove skeleton loading instantly for POM products
    const pomWrapper = document.querySelector(".f-product-single__buy-buttons-and-quantity.is-pom");
    if (pomWrapper) {
      pomWrapper.classList.remove("skeleton-loading");
    }

    // // OPTIONAL: remove any limit classes
    // btn?.classList.remove("disabled", "limit-reached", "is-disabled");

    // OPTIONAL: hide your restriction message block
    document.querySelector(".pom-limit-message")?.remove();
  }

  // skeleton loading
  const skeletonTargets = [".pom-limit-msg-pdp", ".f-product-single__buy-buttons-and-quantity.is-pom"];
  const skeletonTargetsGeneric = [
    ".f-product-single__block--title",
    ".f-product-single__block--price",
    ".f-product-single__block--wrapper--app-block",
    ".f-product-single__block--collapsible_tab",
    ".f-product-single__block--custom_liquid",
    ".f-product-single__buy-buttons-and-quantity:not(.is-pom)",
  ];

  // Utility to apply skeleton effect
  function applySkeleton(el) {
    if (!el.classList.contains("skeleton-loading")) {
      el.classList.add("skeleton-loading");
    }
  }

  // Utility to remove skeleton effect
  function removeSkeleton(el) {
    el.classList.remove("skeleton-loading");
  }

  // Apply skeleton to all matching elements on page load
  skeletonTargets.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => applySkeleton(el));
  });

  // Apply skeleton to all matching elements on page load
  skeletonTargetsGeneric.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => applySkeleton(el));
  });

  // Remove skeleton after 5 seconds
  setTimeout(() => {
    skeletonTargets.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => removeSkeleton(el));
    });
  }, 7000);

  // Remove skeleton after 5 seconds
  setTimeout(() => {
    skeletonTargetsGeneric.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => removeSkeleton(el));
    });
  }, 2000);

  (function () {
    var mobileQuery = window.matchMedia("(max-width: 767px)");
    var stickyBuyButtons = [];
    var stickyTicking = false;
    var html = document.documentElement;
    var bottomHideOffset = 100;
    var bottomRestoreOffset = 160;
    var isSuppressedNearBottom = false;

    function getDistanceFromPageBottom() {
      var scrollBottom = window.scrollY + window.innerHeight;
      var pageBottom = document.documentElement.scrollHeight;
      return pageBottom - scrollBottom;
    }

    function syncStickyBuyButtons() {
      stickyTicking = false;

      stickyBuyButtons = stickyBuyButtons.filter(function (buttonGroup) {
        return buttonGroup.isConnected;
      });

      if (!mobileQuery.matches) {
        html.classList.remove("mobile-buy-buttons--is-sticky");
        isSuppressedNearBottom = false;
        return;
      }

      var distanceFromBottom = getDistanceFromPageBottom();

      if (isSuppressedNearBottom) {
        if (distanceFromBottom > bottomRestoreOffset) {
          isSuppressedNearBottom = false;
        }
      } else if (distanceFromBottom <= bottomHideOffset) {
        isSuppressedNearBottom = true;
      }

      var shouldStickAny = stickyBuyButtons.some(function (buttonGroup) {
        var stickyOriginTop = parseFloat(buttonGroup.dataset.stickyOriginTop || "0");
        var hasReachedTop = window.scrollY >= stickyOriginTop;
        return hasReachedTop && !isSuppressedNearBottom;
      });

      html.classList.toggle("mobile-buy-buttons--is-sticky", shouldStickAny);
    }

    function queueStickyBuyButtonsSync() {
      if (stickyTicking) return;
      stickyTicking = true;
      window.requestAnimationFrame(syncStickyBuyButtons);
    }

    function collectStickyBuyButtons() {
      stickyBuyButtons = Array.from(document.querySelectorAll('.f-product-single__buy-buttons-and-quantity[data-mobile-sticky-buy-buttons="true"]'));

      stickyBuyButtons.forEach(function (buttonGroup) {
        buttonGroup.dataset.stickyOriginTop = String(window.scrollY + buttonGroup.getBoundingClientRect().top);
      });

      if (!stickyBuyButtons.length) {
        html.classList.remove("mobile-buy-buttons--is-sticky");
        isSuppressedNearBottom = false;
      }

      queueStickyBuyButtonsSync();
    }

    collectStickyBuyButtons();
    window.addEventListener("load", collectStickyBuyButtons, { once: true });
    window.addEventListener("scroll", queueStickyBuyButtonsSync, { passive: true });
    window.addEventListener("resize", collectStickyBuyButtons);

    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change", collectStickyBuyButtons);
    } else if (typeof mobileQuery.addListener === "function") {
      mobileQuery.addListener(collectStickyBuyButtons);
    }

    document.addEventListener("shopify:section:load", collectStickyBuyButtons);
    document.addEventListener("shopify:section:reorder", collectStickyBuyButtons);
  })();

  // wishlist header copy
  (function () {
    const originalId = "vitals-wishlist-header";
    const targetId = "vitals-wishlist-header-copy";
    let lastCounterHTML = "";

    function copyWishlistHeaderIfChanged() {
      const original = document.getElementById(originalId);
      const target = document.getElementById(targetId);

      if (!original || !target) return;

      const counter = original.querySelector(".Vtl-WishlistHeader__HeartCounter");
      if (!counter) return;

      const currentHTML = counter.outerHTML;

      // Only update when the counter content or styles change
      if (currentHTML !== lastCounterHTML) {
        lastCounterHTML = currentHTML;
        target.innerHTML = original.innerHTML;
      }
    }

    // Run once at start
    copyWishlistHeaderIfChanged();

    // Check every 5 seconds
    setInterval(copyWishlistHeaderIfChanged, 5000);
  })();

  // custom dropdown for sorting (Shopify facet-filter compatible)
  // custom dropdown for sorting (Shopify facet-filter compatible)
  document.addEventListener("click", function (e) {
    const dropdown = document.getElementById("CustomSortDropdown");
    if (!dropdown) return;

    const select = document.getElementById("SortBy");
    if (!select) return;

    // --- OPEN/CLOSE ---
    if (e.target.closest("#CustomSortDropdown .custom-dropdown_selected")) {
      dropdown.classList.toggle("open");
      return;
    }

    // --- OPTION CLICK ---
    const option = e.target.closest("#CustomSortDropdown .custom-dropdown_option");
    if (option) {
      const value = option.dataset.value;
      const label = option.querySelector(".label").textContent.trim();

      // Update active state
      dropdown.querySelectorAll(".custom-dropdown_option").forEach((o) => o.classList.remove("is-active"));

      option.classList.add("is-active");
      dropdown.querySelector(".selected-text").textContent = label;
      dropdown.classList.remove("open");

      // Update hidden select
      select.value = value;

      // Trigger Shopify facet submit
      const facetForm = document.querySelector("facet-filters-form");
      if (facetForm && typeof facetForm.onSubmitHandler === "function") {
        facetForm.onSubmitHandler();
      } else {
        select.closest("form").submit();
      }

      return;
    }

    // --- CLICK OUTSIDE ---
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove("open");
    }
  });

  // Function to add attributes when the wishlist link appears
  function enhanceWishlistLink() {
    const link = document.querySelector('a.Vtl-WishlistHeader[href="/a/page/wishlist"]');
    if (link && !link.dataset.enhanced) {
      link.setAttribute("aria-label", "Wishlist page link");
      link.setAttribute("class", "Vtl-WishlistHeader caria-haspopupader__link focus-inset");
      link.setAttribute("data-tippy-theme", "color-default");
      link.setAttribute("data-tippy-content", "Wishlist");
      link.setAttribute("data-tippy-placement", "bottom");
      link.setAttribute("aria-haspopup", "dialog");

      // Mark as enhanced to avoid duplicates
      link.dataset.enhanced = "true";
    }
  }

  // Initial check
  enhanceWishlistLink();

  // Observe dynamically added elements (for JS-injected content)
  const observerWishlist = new MutationObserver(enhanceWishlistLink);
  observerWishlist.observe(document.body, { childList: true, subtree: true });

  // touch classes
  if ("ontouchstart" in window || navigator.maxTouchPoints > 0) {
    document.documentElement.classList.add("has-touch");
  } else {
    document.documentElement.classList.add("no-touch");
  }

  // repeat prescription modal handling
  const isLoggedIn = window.customerIsLoggedIn === true;

  document.querySelectorAll('a[href="/pages/repeat-prescription"]').forEach((link) => {
    if (isLoggedIn) {
      link.setAttribute("href", "#repeat-prescription--logged-in");
    } else {
      link.setAttribute("href", "#repeat-prescription--logged-out");
    }
  });

  document.querySelectorAll('.related-collections a[href="/collections/obagi-medical-prescription-skincare"]').forEach((link) => {
    if (isLoggedIn) {
      link.setAttribute("href", "#repeat-prescription--logged-in");
    } else {
      link.setAttribute("href", "#repeat-prescription--logged-out");
    }
  });

  // 1. Find .repeat-prescription__inner
  // Find ALL .repeat-prescription__inner elements

  document.querySelectorAll(".repeat-prescription__inner").forEach((inner) => {
    const parent = inner.parentElement;

    if (parent) {
      // Add base class
      parent.classList.add("repeat-prescription");

      // If the inner element has an ID, add it to parent as data-id
      const innerId = inner.getAttribute("id");
      if (innerId) {
        parent.setAttribute("data-id", innerId);
      }
    }

    // Wrap .repeat-prescription__inner with .repeat-prescription__content
    if (!inner.parentElement.querySelector(".repeat-prescription__content")) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("repeat-prescription__content");

      // Insert wrapper before the inner element
      inner.parentNode.insertBefore(wrapper, inner);

      // Move the inner element inside wrapper
      wrapper.appendChild(inner);
    }

    // Inject the close button if missing
    if (!inner.querySelector(".repeat-prescription__close")) {
      inner.insertAdjacentHTML(
        "afterbegin",
        `
        <button class="f-popup__close repeat-prescription__close btn btn--plain" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      `,
      );
    }
  });

  // 2. Handle open trigger (a[#repeat-prescription--logged-in])
  document.querySelectorAll('a[href="#repeat-prescription--logged-in"]').forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      document.documentElement.classList.add("repeat-prescription-logged-in--is-active");

      // Remove [open] attribute from <drawer-component>
      document.querySelectorAll("drawer-component[open]").forEach((drawer) => {
        drawer.removeAttribute("open");
      });
    });
  });

  // 3. Handle open trigger (a[#repeat-prescription--logged-out])
  document.querySelectorAll('a[href="#repeat-prescription--logged-out"]').forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      document.documentElement.classList.add("repeat-prescription-logged-out--is-active");

      // Remove [open] attribute from <drawer-component>
      document.querySelectorAll("drawer-component[open]").forEach((drawer) => {
        drawer.removeAttribute("open");
      });
    });
  });

  // 3. Handle close trigger (.repeat-prescription__close)
  document.addEventListener("click", function (e) {
    if (e.target.closest(".repeat-prescription__close")) {
      document.documentElement.classList.remove("repeat-prescription-logged-in--is-active");
      document.documentElement.classList.remove("repeat-prescription-logged-out--is-active");
    }
  });

  // smooth scrolling
  initSmoothScrolling(".smooth-scroll-slider", "smoothscroll");

  function initSmoothScrolling(containerSelector, animationName) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const animationDiv = container.querySelector(".animation");
    if (!animationDiv) return;

    let animationWidth = 0;

    // Calculate the total width of all children (including margins)
    const children = Array.from(animationDiv.children);
    children.forEach((child) => {
      const style = window.getComputedStyle(child);
      const margin = parseFloat(style.marginLeft || 0) + parseFloat(style.marginRight || 0);
      animationWidth += child.offsetWidth + margin;
    });

    // Detect visible slides and calculate speed
    const firstChild = children[0];
    if (!firstChild) return;

    const firstChildStyle = window.getComputedStyle(firstChild);
    const firstChildMargin = parseFloat(firstChildStyle.marginLeft || 0) + parseFloat(firstChildStyle.marginRight || 0);
    const firstChildOuterWidth = firstChild.offsetWidth + firstChildMargin;

    const slidesVisible = Math.ceil(container.offsetWidth / firstChildOuterWidth);
    const speed = children.length * 4; // seconds

    // Clone elements for seamless scroll
    children.slice(0, slidesVisible).forEach((child) => {
      animationDiv.appendChild(child.cloneNode(true));
    });

    // Set width of the animation div to hold all items (doubled for clones)
    animationDiv.style.width = animationWidth * 2 + "px";

    // Inject CSS keyframes
    const styleTag = document.createElement("style");
    styleTag.type = "text/css";
    styleTag.textContent = `@keyframes ${animationName} {
          0% { transform: translateX(0); }
          100% { transform: translateX(-${animationWidth}px); }
      }`;
    document.head.appendChild(styleTag);

    // Apply the animation
    animationDiv.style.animation = `${animationName} ${speed}s linear infinite`;
  }

  // Select all spans inside .f-site-nav__item > a
  const navSpans = document.querySelectorAll(".f-site-nav__item > a > span");

  navSpans.forEach((span) => {
    if (span.textContent.trim() === "Sale") {
      span.classList.add("sale");
    }
  });

  // Wait for the Flickity container to exist
  var flickityWrapper = document.querySelector(".f-homepage-reviews__slider");
  // var carouselStatus = document.querySelector(".f-homepage-reviews__counter");

  if (flickityWrapper) {
    // Observe Yotpo reviews
    var observer = new MutationObserver(function (mutations, obs) {
      var yotpoReviews = document.querySelectorAll(".yotpo-reviews-seo-list .yotpo-review");

      if (yotpoReviews.length > 0) {
        // Clear Flickity container
        flickityWrapper.innerHTML = "";

        // Clone reviews into Flickity container
        yotpoReviews.forEach(function (review) {
          flickityWrapper.appendChild(review.cloneNode(true));
        });

        console.log("Copied " + yotpoReviews.length + " Yotpo reviews");

        // Breakpoint: <= 640px is "mobile"
        var isMobile = window.matchMedia("(max-width: 640px)").matches;

        // Initialize Flickity if not already initialized
        if (!flickityWrapper.classList.contains("flickity-enabled")) {
          if (isMobile) {
            var flkty = new Flickity(flickityWrapper, {
              cellAlign: "left",
              contain: true,
              wrapAround: true,
              autoPlay: 5000,
              pageDots: false,
              prevNextButtons: true,
              groupCells: false,
              adaptiveHeight: true,
              cellSelector: ".yotpo-review",
            });
          } else {
            var flkty = new Flickity(flickityWrapper, {
              cellAlign: "left",
              contain: true,
              wrapAround: true,
              autoPlay: 5000,
              pageDots: false,
              prevNextButtons: true,
              groupCells: false,
              adaptiveHeight: false,
              cellSelector: ".yotpo-review",
            });
          }
        }

        // Stop observing once done
        obs.disconnect();
      }
    });

    // Start observing the body for Yotpo injection
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    console.warn("Flickity container or counter not found");
  }

  // Read more toggle functionality (robust + delegated)
  document.addEventListener("click", function (e) {
    const toggle = e.target.closest(".js-read-more-toggle");
    if (!toggle) return;

    // Find the nearest wrapper so the correct description is toggled
    const wrapper = toggle.closest(".js-read-more-wrapper") || document;
    const description = wrapper.querySelector(".js-readmore");

    if (!description) return;

    description.classList.toggle("is-open");
    toggle.classList.toggle("is-open");
    toggle.style.display = "none";
  });

  // Yotpo reviews Flickity slider
  function initYotpoFlickity() {
    const reviewContainer = document.querySelector(".yotpo-reviews");
    if (!reviewContainer) return;

    // Find visible reviews
    const reviews = reviewContainer.querySelectorAll(".yotpo-review:not(.yotpo-hidden)");
    if (reviews.length === 0) return;

    // Prevent duplicate wrapper
    if (reviewContainer.querySelector(".yotpo-reviews__slider")) return;

    // Create Flickity wrapper
    const wrapper = document.createElement("flickity-component");
    wrapper.setAttribute(
      "data-slider-options",
      '{"pageDots": false, "prevNextButtons": true, "adaptiveHeight": true, "cellAlign": "center", "setGallerySize": false, "wrapAround": true, "cellSelector": ".yotpo-review"}',
    );
    wrapper.setAttribute("data-enable-slider", "true");
    wrapper.setAttribute("data-slider-columns", "1");
    wrapper.setAttribute("id", "Media-Gallery-template--17981722132566__main");
    wrapper.setAttribute(
      "class",
      "yotpo-reviews__slider flickity-button-initialized flickity-nav-inner h-full overflow-hidden f-product__media-list--carousel flickity-controls-group-mb__inner",
    );
    wrapper.setAttribute("data-media-layout", "carousel");
    wrapper.setAttribute("role", "list");
    wrapper.setAttribute("style", "--pagination-width: 2.5rem;--row-gap-mobile: .5rem;--column-gap-mobile: .5rem;");

    // Insert wrapper into DOM
    reviewContainer.insertBefore(wrapper, reviews[0]);

    // Move all reviews into the wrapper
    reviews.forEach((review) => {
      wrapper.appendChild(review);
    });
  }

  // Delay for Yotpo to render reviews
  setTimeout(initYotpoFlickity, 2000);

  // mobile slider progress bar
  const isMobileProgress = window.matchMedia("(max-width: 768px)").matches;
  if (isMobileProgress) {
    // Find ALL swiper instances
    const swipers = document.querySelectorAll(".f-swiper");
    if (swipers.length) {
      swipers.forEach((swiper) => {
        // Scope progress bar to THIS swiper only
        const container = swiper.closest(".swiper-wrapper") || swiper.parentElement;

        const progressBar = container.querySelector(".mobile-scroll-progress");
        const progressFill = container.querySelector(".mobile-scroll-progress__fill");

        if (!progressBar || !progressFill) return;

        let userHasScrolled = false;

        const updateProgress = () => {
          const maxScroll = swiper.scrollWidth - swiper.clientWidth;

          if (maxScroll <= 0) {
            progressFill.style.width = "100%";
            return;
          }

          const percent = (swiper.scrollLeft / maxScroll) * 100;
          progressFill.style.width = `${percent}%`;
        };

        swiper.addEventListener("scroll", () => {
          if (!userHasScrolled) {
            userHasScrolled = true;
            progressBar.style.opacity = "1";
          }

          updateProgress();
        });
      });
    }
  }

  // enable flickity for mobile sliders .flickity-enable-mobile
  // Enable Flickity on mobile for elements with .flickity-enable-mobile
  // const isMobileFlickity = window.matchMedia("(max-width: 768px)").matches;
  // if (isMobileFlickity) {
  //   const sliders = document.querySelectorAll(".flickity-enable-mobile");
  //   if (sliders.length) {
  //     sliders.forEach((slider) => {
  //       if (slider.classList.contains("flickity-enabled")) {
  //         const existing = Flickity.data(slider);
  //         if (existing) {
  //           console.log("[Mobile Flickity] Resizing existing instance");
  //           existing.reloadCells();
  //           existing.resize();
  //         }
  //         return;
  //       }

  //       const flkty = new Flickity(slider, {
  //         cellAlign: "left",
  //         contain: true,
  //         wrapAround: true,
  //         pageDots: false,
  //         prevNextButtons: false,
  //         autoPlay: 4000,
  //         groupCells: false,
  //         adaptiveHeight: false,
  //       });

  //       setTimeout(() => {
  //         console.log("[Mobile Flickity] Resizing after init");
  //         flkty.reloadCells();
  //         flkty.resize();
  //       }, 1000);
  //     });
  //   }
  // }

  // smooth scroll to reviews on star rating click
  const reviewsSection = document.getElementById("reviews-section");
  console.log("[Reviews Scroll] reviewsSection:", reviewsSection);

  if (reviewsSection) {
    // Delegated click handler for Yotpo rating
    document.addEventListener("click", (e) => {
      const button = e.target.closest(".yotpo-sr-bottom-line-button");

      if (button) {
        console.log("[Reviews Scroll] Yotpo rating clicked!", button);

        e.preventDefault();

        console.log("[Reviews Scroll] Scrolling…");
        reviewsSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  } else {
    console.log("[Reviews Scroll] No #reviews-section element found");
  }

  // Fix Flickity viewport height after dynamic content loads
  setTimeout(() => {
    console.log("[Flickity Height Fix] Running…");

    // Find every Flickity slider on the page
    const sliders = document.querySelectorAll("flickity-component .flickity-viewport");

    sliders.forEach((viewport) => {
      const cells = viewport.querySelectorAll(".f-column");

      if (!cells.length) return;

      let tallest = 0;

      cells.forEach((cell) => {
        const h = cell.offsetHeight;
        if (h > tallest) tallest = h;
      });

      if (tallest > 0) {
        viewport.style.height = tallest + "px";
        console.log("[Flickity Height Fix] Set height:", tallest, viewport);
      }
    });
  }, 1500); // adjust if needed

  // Mega menu addon description handling
  const descriptions = document.querySelectorAll(".f-custom-card__description");

  descriptions.forEach((desc) => {
    const html = desc.innerHTML.trim().toLowerCase();
    if (!html) return;

    // Hide this element if "desktop" or "mobile"
    if (html === "desktop" || html === "mobile") {
      desc.classList.add("hidden");
    }

    // Find parent: f-site-nav__mega-addon OR mobile-mega-wrapper
    let megaAddon = desc.closest(".f-site-nav__mega-addon");
    if (!megaAddon) {
      megaAddon = desc.closest(".mobile-mega-wrapper");
    }
    if (!megaAddon) return;

    // Create safe class name
    const safeClass = html
      .replace(/<[^>]*>/g, "")
      .replace(/[^a-z0-9\-_]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

    // Add the class
    if (safeClass.length > 0) {
      megaAddon.classList.add(safeClass);
    }
  });

  // Additional content blocks "read more" logic
  const containers = document.querySelectorAll(".additional-content-blocks .rich-text__text.mega-description .metafield-rich_text_field");
  if (containers.length) {
    // Ensure hidden blocks actually hide
    const hideStyle = document.createElement("style");
    hideStyle.textContent = `.is-hidden-extra-block { display: none !important; }`;
    document.head.appendChild(hideStyle);

    containers.forEach((container) => {
      const headings = Array.from(container.querySelectorAll("h2"));
      const paragraphs = Array.from(container.querySelectorAll("p"));

      // Nothing to hide
      if (headings.length <= 1 && paragraphs.length <= 1) return;

      // Hide all except the first h2 + first p
      headings.forEach((h, i) => {
        if (i > 0) h.classList.add("is-hidden-extra-block");
      });
      paragraphs.forEach((p, i) => {
        if (i > 0) p.classList.add("is-hidden-extra-block");
      });

      // Create the read-more button
      const btn = document.createElement("button");
      btn.className = "mega-description-read-more btn btn--underline";
      btn.textContent = "Read more";

      btn.addEventListener("click", () => {
        container.querySelectorAll(".is-hidden-extra-block").forEach((el) => {
          el.classList.remove("is-hidden-extra-block");
        });
        btn.remove();
      });

      container.appendChild(btn);
    });
  }

  // calculate flickity height after all images load
  // Recalculate heights
  function resizeFlickityViewports() {
    document.querySelectorAll("flickity-component").forEach((component) => {
      const viewport = component.querySelector(".flickity-viewport");
      if (!viewport) return;

      const columns = component.querySelectorAll(".f-column");
      if (!columns.length) return;

      // Find tallest .f-column
      let maxHeight = 0;
      columns.forEach((col) => {
        const h = col.offsetHeight;
        if (h > maxHeight) maxHeight = h;
      });

      // Apply height
      viewport.style.height = maxHeight + "px";
    });
  }

  // Run after load
  resizeFlickityViewports();

  // Run again after 1 second (for late images)
  setTimeout(resizeFlickityViewports, 3000);

  // Resize on viewport change
  window.addEventListener("resize", () => {
    resizeFlickityViewports();
  });

  // OPTIONAL: Watches for DOM changes inside any flickity component
  const observerFlickityResize = new MutationObserver(() => {
    resizeFlickityViewports();
  });

  document.querySelectorAll("flickity-component").forEach((component) => {
    observerFlickityResize.observe(component, { childList: true, subtree: true });
  });

  // Convert rich text (#Question + answer) into collapsible FAQ tabs inside `.faqs-content`
  (function initDynamicFaqs() {
    const FAQ_PARENT_SELECTOR = ".faqs-content";
    const FAQ_SOURCE_SELECTOR = ".metafield-rich_text_field";

    const stripTags = (str) => String(str || "").replace(/<[^>]*>/g, "");

    function normalizeFaqHtmlToTextlikeHtml(html) {
      return String(html || "")
        .replace(/&nbsp;/gi, " ")
        .replace(/<br\s*\/?\s*>/gi, "\n")
        .replace(/<\/p\s*>/gi, "\n\n")
        .replace(/<p\b[^>]*>/gi, "")
        .trim();
    }

    function answerSegmentToHtml(answerSegment) {
      const seg = String(answerSegment || "").trim();
      if (!seg) return "";

      const hasBlockTags = /<(ul|ol|li|h\d|div|table|blockquote|p)\b/i.test(seg);
      if (hasBlockTags) {
        return seg.replace(/\n{2,}/g, "<br><br>").replace(/\n/g, "<br>");
      }

      const paragraphs = seg
        .split(/\n{2,}/)
        .map((p) => p.trim())
        .filter(Boolean);

      if (!paragraphs.length) return "";

      return paragraphs.map((p) => `<p class="text-lg">${p.replace(/\n+/g, "<br>")}</p>`).join("");
    }

    function parseFaqPairsFromHtml(rawHtml) {
      const normalized = normalizeFaqHtmlToTextlikeHtml(rawHtml);
      if (!normalized) return [];

      const markerRe = /(^|\n)\s*#([^\n]+)/g;
      const markers = [];
      let match;
      while ((match = markerRe.exec(normalized))) {
        const hashIndex = normalized.indexOf("#", match.index);
        if (hashIndex === -1) continue;

        const titleStart = hashIndex + 1;
        let titleEnd = normalized.indexOf("\n", titleStart);
        if (titleEnd === -1) titleEnd = normalized.length;

        const titleRaw = normalized.slice(titleStart, titleEnd);
        const title = stripTags(titleRaw).trim();
        if (!title) continue;

        markers.push({ hashIndex, titleEnd, title });
      }

      if (!markers.length) return [];

      const pairs = [];
      for (let i = 0; i < markers.length; i++) {
        const current = markers[i];
        const next = markers[i + 1];

        const answerStart = Math.min(current.titleEnd + 1, normalized.length);
        const answerEnd = next ? next.hashIndex : normalized.length;
        const answerSeg = normalized.slice(answerStart, answerEnd);

        const answerHtml = answerSegmentToHtml(answerSeg);
        if (!answerHtml) continue;

        pairs.push({ title: current.title, answerHtml });
      }

      return pairs;
    }

    function buildFaqMarkup(pairs, { blockId }) {
      const wrap = document.createElement("div");
      wrap.className = "collapsible-tabs__content-wrap w-full";

      pairs.forEach((pair, index) => {
        const isFirst = index === 0;

        const motion = document.createElement("motion-element");
        motion.setAttribute("data-motion", "fade-in");
        motion.setAttribute("data-motion-delay", "0");
        motion.className = "collapsible__item-wrap block";
        motion.style.opacity = "1";

        const tab = document.createElement("collapsible-tab");
        tab.className = `collapsible__item no-js-hidden ${isFirst ? "is-selected is-expanded" : "is-collapsed"}`;
        tab.setAttribute("data-block-id", `${blockId || "faqs"}_collapsible-tab-content_${index + 1}`);
        tab.setAttribute("open", isFirst ? "true" : "false");

        const button = document.createElement("button");
        button.className = "collapsible__button text-left font-body h6";
        button.setAttribute("data-trigger", "");
        button.setAttribute("aria-expanded", isFirst ? "true" : "false");

        const buttonText = document.createElement("span");
        buttonText.className = "collapsible__button-text text-lg";
        buttonText.textContent = pair.title;

        const iconSpan = document.createElement("span");
        iconSpan.setAttribute("data-collapsible-icon", "");
        iconSpan.innerHTML =
          '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L6 6L1 1" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        button.appendChild(buttonText);
        button.appendChild(iconSpan);

        const content = document.createElement("div");
        content.className = "collapsible__content";
        content.setAttribute("data-content", "");
        content.setAttribute("aria-hidden", isFirst ? "false" : "true");
        content.setAttribute("style", isFirst ? "height:auto;" : "height:0;");

        const contentInner = document.createElement("div");
        contentInner.className = "collapsible__content-inner rte";

        const rte = document.createElement("div");
        rte.className = "rte";
        rte.innerHTML = pair.answerHtml;

        contentInner.appendChild(rte);
        content.appendChild(contentInner);

        tab.appendChild(button);
        tab.appendChild(content);

        motion.appendChild(tab);
        wrap.appendChild(motion);
      });

      return wrap;
    }

    function enhanceFaqBlock(blockEl) {
      if (!blockEl || blockEl.nodeType !== 1) return;

      const sources = Array.from(blockEl.querySelectorAll(FAQ_SOURCE_SELECTOR));
      if (!sources.length) return;

      sources.forEach((source) => {
        if (!source || source.dataset.dynamicFaqsInitialized === "true") return;

        const rawHtml = source.innerHTML;
        const pairs = parseFaqPairsFromHtml(rawHtml);
        if (!pairs.length) return;

        source.innerHTML = "";
        source.appendChild(buildFaqMarkup(pairs, { blockId: blockEl.id || "faqs" }));
        source.dataset.dynamicFaqsInitialized = "true";
      });
    }

    function enhanceAllFaqBlocks(root = document) {
      root.querySelectorAll(FAQ_PARENT_SELECTOR).forEach(enhanceFaqBlock);
    }

    enhanceAllFaqBlocks(document);

    document.addEventListener("shopify:section:load", (e) => enhanceAllFaqBlocks(e.target));

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (!node || node.nodeType !== 1) return;
          if (node.matches?.(FAQ_PARENT_SELECTOR)) enhanceFaqBlock(node);
          node.querySelectorAll?.(FAQ_PARENT_SELECTOR).forEach(enhanceFaqBlock);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
}
